<template>
  <div class="w-full">
    <div id="otp" class="w-full flex items-center space-x-2">
      <input
        v-for="(field, key) in fields"
        :id="key"
        :key="key"
        :ref="el => { if (el) fieldRefs[`field-${key}`] = el }"
        v-model="field.value"
        class="aspect-square w-10 flex-grow text-center text-2xl tracking-tighter text-gray-700 dark:text-white border dark:border-gray-800 dark:bg-gray-900 rounded-md py-3 leading-none font-bold form-control form-control-solid focus:border-blue-300 focus:ring-4 focus:ring-blue-200 focus:shadow-outline transition-all"
        type="number"
        maxlength="1"
        placeholder="○"
        @input="onInput"
        @keydown="onKeydown"
        @paste.prevent="onPaste"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
const KEY_CODE = {
  backspace: 8,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  v: 86,
}

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const fields = reactive<Record<number, { value: string }>>({
  0: { value: '' },
  1: { value: '' },
  2: { value: '' },
  3: { value: '' },
  4: { value: '' },
  5: { value: '' },
})

const fieldRefs = ref<Record<string, any>>({})

const _value = computed(() => {
  return Object.values(fields)
    .map(field => field.value)
    .join('')
})

watch(_value, (value) => {
  emit('update:modelValue', value)
})

function onPaste(event: ClipboardEvent) {
  const code = (event.clipboardData || (window as any).clipboardData).getData('text')

  if (typeof code !== 'string') { return }

  const string = code.replace(/\D/g, '')
  const chars = string.split('')

  for (const key of Object.keys(fields)) {
    if (chars[Number(key)]) {
      fields[Number(key)].value = chars[Number(key)]
      focusField(Number(key))
    }
  }
}

function onInput(event: Event) {
  const target = event.target as HTMLInputElement
  const id = Number(target.id)
  focusField(id + 1)
  target.blur()
}

function onKeydown(event: KeyboardEvent) {
  const target = event.target as HTMLInputElement
  const id = Number(target.id)
  const field = fields[id]

  switch (event.keyCode) {
    case KEY_CODE.v: {
      break
    }
    case KEY_CODE.backspace: {
      event.preventDefault()
      if (field.value !== null) {
        field.value = ''
      }
      focusField(id - 1)
      break
    }
    case KEY_CODE.left: {
      event.preventDefault()
      focusField(id - 1)
      break
    }
    case KEY_CODE.right: {
      event.preventDefault()
      focusField(id + 1)
      break
    }
    default: {
      if (!(/^[0-9]$/i.test(event.key))) {
        event.preventDefault()
      }
      if (target.value !== '') {
        target.value = ''
      }
      break
    }
  }
}

function focusField(id: number) {
  const field = fieldRefs.value[`field-${id}`] as HTMLInputElement | undefined

  if (!field) {
    return null
  }
  return field.focus()
}
</script>
